const white = { 0: '#FFFFFF' };
export default white;
